export class AspectKeyEnabled {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    get aspectKey() {
        return this.parent;
    }
    get aspect() {
        return this.aspectKey.aspect;
    }
    get enabledTraits() {
        return this.aspectKey.keyAttached.attachedTraits.filter(at => at.attachedActive.isAtEnabled);
    }
    get conditionTrueTraits() {
        return this.aspectKey.keyAttached.attachedTraits.filter(at => at.attachedCondition.isConditionTrue);
    }
}
